(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drawer-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('w4-cart-add')) {
  customElements.define('w4-cart-add', class extends HTMLElement {
    connectedCallback() {
      if (this.boundSubmit) return;
      this.boundSubmit = this.submit.bind(this);
      this.addEventListener('submit', this.boundSubmit);
      this.lockButton = () => { const button = this.querySelector('button'); if (button) button.disabled = true; };
      this.unlockButton = () => { const button = this.querySelector('button'); if (button && !this.busy) button.disabled = false; };
      document.addEventListener('baseline:cart:lock', this.lockButton);
      document.addEventListener('baseline:cart:unlock', this.unlockButton);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.boundSubmit);
      document.removeEventListener('baseline:cart:lock', this.lockButton);
      document.removeEventListener('baseline:cart:unlock', this.unlockButton);
      this.boundSubmit = null;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || document.querySelector('[data-cart-drawer][aria-busy="true"]')) return;
      const form = event.target;
      if (!form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('[role="alert"]');
      const drawer = this.closest('[data-cart-drawer]');
      const label = button.textContent;
      const data = new FormData(form);
      data.set('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
      data.set('sections_url', window.location.pathname);
      this.busy = true;
      if (drawer) drawer.setAttribute('aria-busy', 'true');
      document.dispatchEvent(new CustomEvent('baseline:cart:lock'));
      button.disabled = true;
      button.textContent = form.dataset.loading;
      error.textContent = '';
      try {
        const response = await fetch(form.action + '.js', {
          method: 'POST', body: data,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
        if (!result.sections || !result.sections['cart-items'] || !result.sections['cart-item-count'] || !result.sections['cart-live-region']) {
          window.location.assign(window.theme.routes.cart_url);
          return;
        }
        document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true, detail: { response: result, sourceId: form.id }
        }));
      } catch (exception) {
        error.textContent = exception.message || form.dataset.error;
      } finally {
        this.busy = false;
        if (drawer) drawer.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
        button.disabled = false;
        button.textContent = label;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
